import React from 'react';
import EventWrapper from './EventWrapper';

const CalendarEventWrapper = props => <EventWrapper showTimes={false} {...props.event} />;

export default CalendarEventWrapper;
